const aaa = [
	{
		path: "fileList",
		component: () => import("@/views/file/fileList.vue"),
		meta:{title:'全部文件'},
	}
]
export default aaa;